/**
 * Colours as the wire carries them.
 *
 * Kept apart from the picker so a number can be turned into a swatch, and back,
 * without pulling a component in behind it.
 */

/** A hex string as the number the wire carries. */
export const colourValue = (hex: string): number => Number.parseInt(hex.replace('#', ''), 16) || 0;

/** And back the other way, for a picker that only speaks in strings. */
export const colourText = (value: number): string => `#${value.toString(16).padStart(6, '0')}`;

/** What somebody starts as, before they have chosen anything. */
export const DEFAULT_SKIN = '#6b4a35';
export const DEFAULT_EYES = '#f2efe6';
